module.exports = __webpack_public_path__ + "static/media/Bot_Nova_Nombre.81b64cdf.png";